module.exports = __webpack_public_path__ + "img/IMG_5910.a3065323.jpg";